import React from "react";
import { Col, Row } from "react-bootstrap";

// Core Tech Icons
import C from "../../Assets/TechIcons/C++.svg";
import Javascript from "../../Assets/TechIcons/Javascript.svg";
import Typescript from "../../Assets/TechIcons/Typescript.svg";
import ReactIcon from "../../Assets/TechIcons/React.svg";
import Node from "../../Assets/TechIcons/Node.svg";
import Express from "../../Assets/TechIcons/expressjs.png";
import Mongo from "../../Assets/TechIcons/Mongo.svg";
import SQL from "../../Assets/TechIcons/SQL.svg";
import Tailwind from "../../Assets/TechIcons/Tailwind.svg";
import MUI from "../../Assets/TechIcons/MUI.svg";
import Git from "../../Assets/TechIcons/Git.svg";
import Docker from "../../Assets/TechIcons/Docker.svg";
import Postman from "../../Assets/TechIcons/Postman.svg";
import AWS from "../../Assets/TechIcons/AWS.svg";

// GenAI
import Python from "../../Assets/TechIcons/Python.svg";
import OpenAI from "../../Assets/TechIcons/openai.png";
import LangChain from "../../Assets/TechIcons/langchain.png";
import HuggingFace from "../../Assets/TechIcons/huggingface.jpg";
import Streamlit from "../../Assets/TechIcons/streamlit.jpg";

// Design
import Canva from "../../Assets/TechIcons/canva.jpg";

function Techstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>

      {/* Languages */}
      <Col xs={4} md={2} className="tech-icons">
        <img src={C} alt="C" />
        <div className="tech-icons-text">C</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={Javascript} alt="JavaScript" />
        <div className="tech-icons-text">JavaScript</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={Typescript} alt="TypeScript" />
        <div className="tech-icons-text">TypeScript</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={Python} alt="Python" />
        <div className="tech-icons-text">Python</div>
      </Col>

      {/* Frontend */}
      <Col xs={4} md={2} className="tech-icons">
        <img src={ReactIcon} alt="React" />
        <div className="tech-icons-text">React.js</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={Tailwind} alt="Tailwind CSS" />
        <div className="tech-icons-text">Tailwind CSS</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={MUI} alt="Material UI" />
        <div className="tech-icons-text">Material UI</div>
      </Col>

      {/* Backend */}
      <Col xs={4} md={2} className="tech-icons">
        <img src={Node} alt="Node.js" />
        <div className="tech-icons-text">Node.js</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={Express} alt="Express.js" />
        <div className="tech-icons-text">Express.js</div>
      </Col>

      {/* Database */}
      <Col xs={4} md={2} className="tech-icons">
        <img src={Mongo} alt="MongoDB" />
        <div className="tech-icons-text">MongoDB</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={SQL} alt="PostgreSQL" />
        <div className="tech-icons-text">PostgreSQL</div>
      </Col>

      {/* Dev Tools */}
      <Col xs={4} md={2} className="tech-icons">
        <img src={Git} alt="Git" />
        <div className="tech-icons-text">Git</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={Docker} alt="Docker" />
        <div className="tech-icons-text">Docker</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={Postman} alt="Postman" />
        <div className="tech-icons-text">Postman</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={AWS} alt="AWS" />
        <div className="tech-icons-text">AWS</div>
      </Col>

      {/* GenAI */}
      <Col xs={4} md={2} className="tech-icons">
        <img src={OpenAI} alt="OpenAI" />
        <div className="tech-icons-text">OpenAI API</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={LangChain} alt="LangChain" />
        <div className="tech-icons-text">LangChain</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={HuggingFace} alt="Hugging Face" />
        <div className="tech-icons-text">Hugging Face</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={Streamlit} alt="Streamlit" />
        <div className="tech-icons-text">Streamlit</div>
      </Col>

      {/* Design */}
      <Col xs={4} md={2} className="tech-icons">
        <img src={Canva} alt="Canva" />
        <div className="tech-icons-text">Canva</div>
      </Col>

    </Row>
  );
}

export default Techstack;
